let isMobileToggleBound = false;

function aboutOurTeamToggle() {
    const isMobile = $(window).width() < 1024;

    if (isMobile && !isMobileToggleBound) {
        $('body').on('click.mobileToggle', '.about_our_team > .wp-block-heading', function (e) {
            e.preventDefault();
            $(this).toggleClass('open');
            $(this).siblings().slideToggle(150, function () {
                if ($(this).is(':visible')) {
                    $(this).css('display', 'flex');
                }
            });
        });
        isMobileToggleBound = true;
    } else if (!isMobile && isMobileToggleBound) {
        $('body').off('click.mobileToggle');
        isMobileToggleBound = false;
    }
}

$(document).ready(function () {
    aboutOurTeamToggle();
    $(window).on('resize', aboutOurTeamToggle);
});